module.exports = __webpack_public_path__ + "img/full6-min.120dc5f5.png";